import {createReducer, on} from '@ngrx/store';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {
  clearClusterInstanceTypesState,
  loadClusterInstanceTypes,
  loadClusterInstanceTypesFailure,
  loadClusterInstanceTypesSuccess
} from './organization-account.cluster-instance-types.actions';


export interface State {
  record: InstanceType[];
  error: any;
  loaded: boolean;
  loading: boolean;
  region: RegionCode | null;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
  region: null
};


export const loadClusterInstanceTypesReducer = createReducer(
  initialState,

  on(loadClusterInstanceTypes, (state: State, action: { region: RegionCode }): State => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
    region: action.region
  })),
  on(loadClusterInstanceTypesSuccess, (state: State, action: { data: InstanceType[] }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
    region: state.region
  })),
  on(loadClusterInstanceTypesFailure, (state: State, action: { error: any }): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false,
    region: state.region
  })),
  on(clearClusterInstanceTypesState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false,
    region: null
  }))
);
